import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, Target, Wrench, MonitorPlay, Cpu, Megaphone } from "lucide-react";
import Reveal from "../components/Reveal";
import { services, process } from "../mock/data";

const iconMap = { Building2, Target, Wrench, MonitorPlay, Cpu, Megaphone };

const Services = () => {
  return (
    <main>
      {/* HERO */}
      <section className="relative overflow-hidden" style={{ paddingTop: 160, paddingBottom: 72 }}>
        <div className="glow-orb" style={{ width: 380, height: 380, background: "var(--oo-orange)", top: "-10%", right: "-6%", opacity: 0.18 }} />
        <div className="absolute inset-0 grid-overlay" style={{ opacity: 0.35 }} />
        <div className="oo-container relative">
          <Reveal><span className="oo-eyebrow">What We Do</span></Reveal>
          <Reveal delay={80}>
            <h1 className="font-display font-extrabold" style={{ fontSize: "clamp(38px,6vw,76px)", lineHeight: 1.03, marginTop: 20, letterSpacing: "-0.02em", maxWidth: 900 }}>
              End-to-End <span className="text-accent">OOH Solutions</span>
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p style={{ color: "var(--oo-muted)", fontSize: 18, lineHeight: 1.7, maxWidth: 640, marginTop: 24 }}>
              From strategy to steel to screens — we own every part of the outdoor advertising chain, ensuring seamless execution and measurable impact.
            </p>
          </Reveal>
        </div>
      </section>

      {/* SERVICES LIST */}
      <section style={{ paddingBottom: 96 }}>
        <div className="oo-container">
          <div className="grid gap-6 md:grid-cols-2">
            {services.map((s, i) => {
              const Icon = iconMap[s.icon];
              return (
                <Reveal key={s.no} delay={(i % 2) * 80}>
                  <div className="oo-card h-full" style={{ padding: 36 }}>
                    <div className="flex items-start justify-between">
                      <div className="inline-flex items-center justify-center" style={{ width: 58, height: 58, borderRadius: 16, background: "var(--oo-orange-soft)" }}>
                        <Icon size={26} className="text-accent" />
                      </div>
                      <span className="font-display" style={{ fontSize: 44, fontWeight: 800, color: "var(--oo-surface-2)" }}>{s.no}</span>
                    </div>
                    <h3 className="font-display" style={{ fontSize: 24, fontWeight: 700, marginTop: 22 }}>{s.title}</h3>
                    <p style={{ color: "var(--oo-muted)", lineHeight: 1.75, marginTop: 14, fontSize: 15 }}>{s.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="oo-section" style={{ background: "var(--oo-bg-2)" }}>
        <div className="oo-container">
          <Reveal>
            <span className="oo-eyebrow">How We Work</span>
            <h2 className="font-display font-extrabold" style={{ fontSize: "clamp(30px,4.5vw,52px)", letterSpacing: "-0.02em", marginTop: 14 }}>
              Our <span className="text-accent">Process</span>
            </h2>
          </Reveal>
          <div style={{ marginTop: 48 }}>
            {process.map((p, i) => (
              <Reveal key={p.no} delay={i * 60}>
                <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-10" style={{ padding: "28px 0", borderTop: "1px solid var(--oo-border)" }}>
                  <span className="font-display text-accent" style={{ fontSize: 22, fontWeight: 800, minWidth: 56 }}>{p.no}</span>
                  <h3 className="font-display" style={{ fontSize: "clamp(22px,3vw,32px)", fontWeight: 700, flex: "0 0 auto", minWidth: 260 }}>{p.title}</h3>
                  <p style={{ color: "var(--oo-muted)", fontSize: 16, lineHeight: 1.7 }}>{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="oo-section">
        <div className="oo-container text-center">
          <Reveal>
            <h2 className="font-display font-extrabold" style={{ fontSize: "clamp(30px,4.5vw,52px)", letterSpacing: "-0.02em" }}>
              Your Campaign <span className="text-accent">Starts Here</span>
            </h2>
            <Link to="/contact" className="btn-primary" style={{ marginTop: 30 }}>
              Request a Proposal <ArrowUpRight size={18} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Services;
